import { defineCustomElement } from "vue";
import AddEmail from "#/account/email/AddEmailForm.vue";
import AddPhone from "#/account/phone/AddPhoneForm.vue";
import ChangePasswordForm from "#/account/password/ChangePasswordForm.vue";
import FormDropdown from "./form/FormDropdown.vue";
import ScrollToTop from "#/form/ScrollToTop.vue";
import FormBalance from "#/form/FormBalance.vue";
import CompanyBalance from "#/components/balance/CompanyBalance.vue";
import OrderForm from "#/form/OrderForm.vue";
import OrderActions from "#/components/order/OrderActions.vue";
import CitySelect from "#/components/header/CitySelect.vue";
import TranslationToggle from "#/components/translation/TranslationToggle.vue";

const CEAccountAddEmail = defineCustomElement(AddEmail, {
  shadowRoot: false,
});
const CEAccountAddPhone = defineCustomElement(AddPhone, {
  shadowRoot: false,
});
const CEChangePasswordForm = defineCustomElement(ChangePasswordForm, {
  shadowRoot: false,
});
const CEVacancyActions = defineCustomElement(FormDropdown, {
  shadowRoot: false,
});
const CEScrollToTop = defineCustomElement(ScrollToTop, {
  shadowRoot: false,
});
const CEFormBalance = defineCustomElement(FormBalance, {
  shadowRoot: false,
});
const CECompanyBalance = defineCustomElement(CompanyBalance, {
  shadowRoot: false,
});
const CEOrderForm = defineCustomElement(OrderForm, {
  shadowRoot: false,
});
const CEOrderActions = defineCustomElement(OrderActions, {
  shadowRoot: false,
});
const CECitySelect = defineCustomElement(CitySelect, {
  shadowRoot: false,
});
const CETranslationToggle = defineCustomElement(TranslationToggle, {
  shadowRoot: false,
});

customElements.define("add-email", CEAccountAddEmail);
customElements.define("add-phone", CEAccountAddPhone);
customElements.define("change-password", CEChangePasswordForm);
customElements.define("form-dropdown", CEVacancyActions);
customElements.define("scroll-to-top", CEScrollToTop);
customElements.define("form-balance", CEFormBalance);
customElements.define("company-balance", CECompanyBalance);
customElements.define("order-form", CEOrderForm);
customElements.define("order-actions", CEOrderActions);
customElements.define("city-select", CECitySelect);
customElements.define("translation-toggle", CETranslationToggle);